import { Routes, Route } from "react-router-dom";
import Products from "./pages/products";
import MyOrders from "./pages/MyOrders";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Products />} />
      <Route path="/orders" element={<MyOrders />} />
    </Routes>
  );
}

export default App;